<template>
  <div class="container_self">
    <h3>查看JSON文件</h3>
    <el-row class="search_parent">
      <!-- <el-row>搜索</el-row> -->
      <el-form :model="searchForm" :inline="true" size="mini">
        <el-form-item label="域名">
          <el-input
            v-model="searchForm.domain"
            clearable
            placeholder="请输入客户名称"
          ></el-input>
          <el-button type="warning" icon="el-icon-search" @click="search">搜索</el-button>
        </el-form-item>
      </el-form>
    </el-row>

    <el-row v-show="showdescriptions">
      <el-descriptions title="文件信息" border>
        <el-descriptions-item label="域名">{{ result.domain }}</el-descriptions-item>
        <el-descriptions-item label="GAID">{{ result.gaID }}</el-descriptions-item>
        <el-descriptions-item label="是否开启锚定">{{
          result.bottomAnchorFlag ? "是" : "否"
        }}</el-descriptions-item>
        <el-descriptions-item label="是否开启穿插">{{
          result.adxInterstitialFlag ? "是" : "否"
        }}</el-descriptions-item>
        <el-descriptions-item label="锚定广告代码">{{
          result.adxBottomAnchorAdUnit
        }}</el-descriptions-item>
        <el-descriptions-item label="穿插广告代码">{{
          result.adxInterstitialAdUnit
        }}</el-descriptions-item>
        <el-descriptions-item label="首页广告一代码">{{
          result.contentAds[0].adUnit
        }}</el-descriptions-item>
        <el-descriptions-item label="首页广告一尺寸">{{
          result.contentAds[0].size.join("*")
        }}</el-descriptions-item>
        <el-descriptions-item label="首页广告一unitId">{{
          result.contentAds[0].unitId
        }}</el-descriptions-item>
        <el-descriptions-item label="首页广告二代码">{{
          result.contentAds[1].adUnit
        }}</el-descriptions-item>
        <el-descriptions-item label="首页广告二尺寸">{{
          result.contentAds[1].size.join("*")
        }}</el-descriptions-item>
        <el-descriptions-item label="首页广告二unitId">{{
          result.contentAds[1].unitId
        }}</el-descriptions-item>
        <el-descriptions-item label="copyright">{{
          result.pageGlobalConfig.copyright
        }}</el-descriptions-item>
        <el-descriptions-item label="vastTag">{{
          result.vastTag
        }}</el-descriptions-item>
        <el-descriptions-item label="激励广告">{{
          result.awardUnit
        }}</el-descriptions-item>
      </el-descriptions>

      <el-row style="margin-top: 40px"
        ><el-button type="primary" @click="editJson" style="float: right"
          >修改</el-button
        ></el-row
      >
    </el-row>
  </div>
</template>

<script>
import { axiosGet } from "@/assets/ajaxFn";
export default {
  data() {
    return {
      searchForm: {
        domain: "",
      },
      result: {
        adxBottomAnchorAdUnit: "",
        adxInterstitialAdUnit: "",
        adxInterstitialFlag: true,
        adxOrAdsFlag: true,
        bottomAnchorFlag: true,
        channelID: "",
        collectDataFlag: true,
        domain: "",
        gaID: "",
        contentAds: [
          {
            adUnit: "",
            arrowDown: 0,
            arrowUp: 0,
            size: [],
            unitId: "",
          },
          {
            adUnit: "",
            arrowDown: 0,
            arrowUp: 0,
            size: [],
            unitId: "",
          },
        ],
        pageGlobalConfig: {
          color: "",
          copyright: "",
          lightColor: "",
        },
        slotAccount: "",
        slotChannelTag: "",
        topAnchorFlag: true,
        websiteType: "",
      },
      showdescriptions: false,
    };
  },
  methods: {
    search() {
      axiosGet("/api/ad_json_file/info", { domain: (this.searchForm.domain).trim() }).then(
        (res) => {
          if (res.code == 0) {
            this.result = res.data;
            this.showdescriptions = true;
          }
        }
      );
    },
    editJson() {
      sessionStorage.setItem("editJson", JSON.stringify(this.result));
      this.$router.push("/addJson");
    },
  },
};
</script>

<style>
.el-descriptions {
  color: #fff !important;
}
.el-descriptions * {
  background-color: rgb(16, 32, 54);
}
.el-descriptions__body {
  color: #fff !important;
}
.el-descriptions-item__label.is-bordered-label {
  font-weight: 700;
  color: #fff !important;
  background: #263953 !important;
}
.el-descriptions :not(.is-bordered) .el-descriptions-item__cell{
  max-width: 300px;
}
</style>



// WEBPACK FOOTER //
// src/components/view/JsonManager/checkJson.vue